import {Box, Collapse, Stack, Typography} from "@mui/material";
import {memo} from "react";
import {Link} from "react-router-dom";
import {Dangerous, Warning} from "@mui/icons-material";

const ToolHeader = ({tool, err}) => {
  return (
    <Stack>
      <Box
        sx={{
          p: '16px',
          textAlign: 'center',
          backgroundColor: 'base.rothko4'
        }}
      >
        <Typography fontSize={24}
                    fontWeight={'bold'}
                    color="text.light">
          {tool}
        </Typography>
      </Box>
      <Collapse in={Boolean(err)}>
        <Box
          sx={{
            p: 2,
            mt: 1,
            textAlign: "center",
            backgroundColor: "reds.rothko2",
          }}
        >
          <Typography mb={1} fontSize={14} fontWeight="bold" color="white" sx={{ lineHeight: 1 }}>
            <Warning sx={{fontSize: '18px', color: 'white', verticalAlign: "middle", mr: 1 }}/>
            SERVER ERROR [500]
            <Warning sx={{fontSize: '18px', color: 'white', verticalAlign: "middle", ml: 1 }}/>
          </Typography>
          <Typography fontWeight="bold" color="white">
            Encountered an unresolved error with the current widget parameters.<br />
            Try reverting recent changes or resetting the tool to its default state.<br />
          </Typography>
          <Typography
            component={Link}
            to={"https://www.predsci.com/portal/contact.php"}
            color={"white"}
            fontWeight={"bold"}
            sx={{
              textDecoration: 'none',
              color: 'white',
              '&:hover': {
                textShadow: '2px 2px 6px lightblue, -2px -2px 6px lightyellow',
              }
            }}
          >
              If the issue persists, please contact the PSI team for further assistance.
          </Typography>
        </Box>
      </Collapse>

  </Stack>
  );
};

export default memo(ToolHeader);